import { render, staticRenderFns } from "./FoodOptionSelect.vue?vue&type=template&id=294a5a64&scoped=true"
import script from "./FoodOptionSelect.vue?vue&type=script&lang=js"
export * from "./FoodOptionSelect.vue?vue&type=script&lang=js"
import style0 from "./FoodOptionSelect.vue?vue&type=style&index=0&id=294a5a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294a5a64",
  null
  
)

export default component.exports